import adminRequest from 'utils/adminRequest'

export const initiateRoleBasedGeneration = (data) =>
  adminRequest.post('/assessment/initiateRoleBasedGeneration', data)

export const getSetGroups = (params) =>
  adminRequest.get('/assessment/setGroups', { params })

export const getSetGroupsPendingCount = (params) =>
  adminRequest.get('/assessment/setGroups/pendingCount', { params })

export const getSetGroup = (groupId) =>
  adminRequest.get(`/assessment/setGroup/${groupId}`)

export const getSetGroupSet = (groupId, setId) =>
  adminRequest.get(`/assessment/setGroup/${groupId}/set/${setId}`)

export const approveSet = (groupId, setId, approvedBy) =>
  adminRequest.post(`/assessment/setGroup/${groupId}/set/${setId}/approve`, { approvedBy })

export const rejectSet = (groupId, setId) =>
  adminRequest.post(`/assessment/setGroup/${groupId}/set/${setId}/reject`)

export const regenerateQuestion = (groupId, setId, questionId) =>
  adminRequest.post(`/assessment/setGroup/${groupId}/set/${setId}/question/${questionId}/regenerate`)

export const assignStudentsToGroup = (groupId) =>
  adminRequest.post(`/assessment/setGroup/${groupId}/assignStudents`)

export const retryFailedGeneration = (groupId) =>
  adminRequest.post(`/assessment/setGroup/${groupId}/retry`)

// Broadcast Assessment APIs
export const createBroadcast = (data) =>
  adminRequest.post('/assessment/broadcast/create', data)

export const getBroadcast = (broadcastId) =>
  adminRequest.get(`/assessment/broadcast/${broadcastId}`)

export const updateBroadcast = (broadcastId, data) =>
  adminRequest.put(`/assessment/broadcast/${broadcastId}`, data)

export const pauseBroadcast = (broadcastId) =>
  adminRequest.post(`/assessment/broadcast/${broadcastId}/pause`)

export const resumeBroadcast = (broadcastId) =>
  adminRequest.post(`/assessment/broadcast/${broadcastId}/resume`)

export const endBroadcast = (broadcastId) =>
  adminRequest.post(`/assessment/broadcast/${broadcastId}/end`)

export const updateBroadcastLabels = (broadcastId, labels) =>
  adminRequest.put(`/assessment/broadcast/${broadcastId}/labels`, { broadcastLabelSpecialisations: labels })

export const updateBroadcastScope = (broadcastId, scopes) =>
  adminRequest.put(`/assessment/broadcast/${broadcastId}/scope`, { broadcastScope: scopes })

export const expandBroadcastPool = (broadcastId, addSets) =>
  adminRequest.post(`/assessment/broadcast/${broadcastId}/expand-pool`, { addSets })

export const getBroadcastScopeHierarchy = (broadcastId) =>
  adminRequest.get(`/assessment/broadcast/${broadcastId}/scope-hierarchy`)

// Distinct passing years that have students for a campus + degree + stream.
// Used by the broadcast creation scope picker (no broadcastId yet).
export const getBroadcastPassingYears = ({ campusId, degreeId, streamId }) =>
  adminRequest.get('/assessment/broadcast-passing-years', {
    params: { campusId, degreeId, streamId },
  })

/**
 * Subscribe to SSE events for a topic.
 * Returns an EventSource instance. Call .close() to unsubscribe.
 */
export const subscribeSSE = (topic) => {
  const baseUrl = (adminRequest.defaults.baseURL || process.env.ADMIN_API_URL || '').replace(/\/$/, '')
  const url = `${baseUrl}/events/subscribe?topic=${encodeURIComponent(topic)}`
  return new EventSource(url)
}
